/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Table } from 'react-bootstrap';
import styles from './styles.scss';

const LoadingTable = (props) => {
  const { rows, children, cols, ...restProps } = props;
  return (
    <Table {...restProps}>
      {children}
      <tbody>
        {_.range(rows).map(idx => (
          <tr key={String(idx)}>
            <td colSpan={cols}>
              <div className={styles.loadingBar} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

LoadingTable.defaultProps = {
  children: null,
  rows: 10,
};
LoadingTable.propTypes = {
  children: React.PropTypes.node,
  rows: React.PropTypes.number,
  cols: React.PropTypes.number.isRequired,
};

export default LoadingTable;




// WEBPACK FOOTER //
// ./src/components/LoadingTable/index.jsx